import React from 'react'
import CIcon from '@coreui/icons-react'
import { cilGroup, cilSpeedometer, cilBasket } from '@coreui/icons'
import { CNavItem } from '@coreui/react'

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Usuários',
    to: '/users',
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Parceiros',
    to: '/partners',
    icon: <CIcon icon={cilBasket} customClassName="nav-icon" />,
  },
]

export default _nav
